import React from "react";
import { withRouter } from "react-router-dom";
import { Utils } from "../../utils/Utils";
import { COURSE_API } from "../../utils/Req";
import { setUserStorage } from '../../server/commonFun';
import "../../static/css/layout-menu.css";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: false,
            eng_name: "",
            grapes: 0,
            stars: 0,
            level: 1,
            photo: "",
            showLeaderBoard: false, //true显示勤学 false不显示
            leaderBoardPageURL: ""
        };
    }

    componentDidMount() {
        // 获取用户信息

        this.PutaoID = Utils.getCookie("putaoid");
        this.Token = encodeURIComponent(Utils.getCookie("token"));

        fetch(
            `${COURSE_API.user}?putaoid=${this.PutaoID}&token=${this.Token}&from=pc`,
            { method: "GET" }
        )
            .then(res => res.json())
            .then(data => {
                if (data.code === 200) {
                    this.setState({
                        grapes: data.grapes,
                        stars: data.stars,
                        eng_name: data.eng_name,
                        level: data.course_position.level,
                        photo: data.photo,
                        showLeaderBoard: data.showLeaderBoard,
                        leaderBoardPageURL: data.leaderBoardPageURL,
                        cid: `${data.course_position.level}_${data.course_position.unit}_${
                            data.course_position.lesson
                            }`
                    }, () => {
                        setUserStorage(data);
                    });
                } else if (data.code === 499) {
                    window.location = `${window.location.pathname}${window.location.search}#/login`;
                }
            });
    }

    clearCookies() {
        Utils.delCookie("putaoid", window.location.hostname, "/");
        Utils.delCookie("token", window.location.hostname, "/");

        window.location = `${window.location.pathname}${window.location.search}#/login`;
    }

    showAndHideMenu(e) {
        // e.preventDefault();

        if (
            typeof e.target.className !== "string" ||
            (typeof e.target.className === "string" &&
                e.target.className.indexOf("menu") < 0)
        ) {
            this.setState({
                showMenu: false
            });
        }
    }

    render() {
        const { showMenu, eng_name, grapes, stars, photo, cid, showLeaderBoard, leaderBoardPageURL } = this.state;
        const { page, showInfo, showFM } = this.props;

        return (
            <div
                className="page-container"
                onClick={e => {
                    this.showAndHideMenu(e);
                }}
            >
                {/* <ul className={showMenu ? "menu-ul" : "menu-ul menu-hide"}>
          <li
            onClick={() => {
              window.location = `${window.location.pathname}${window.location.search}#/`;
            }}
          >
            <div className="menu-logo menu-index" />
            <div
              style={
                page === "index"
                  ? { color: "#8540FF", borderBottom: "1px solid #8540FF" }
                  : {}
              }
            >
              首页
            </div>
          </li>
          <li
            onClick={() => {
              window.location = `${window.location.pathname}${window.location.search}#/path`;
            }}
          >
            <div className="menu-logo menu-my-class" />
            <div>我的课堂</div>
          </li>
          <li
            onClick={() => {
              window.location = `${window.location.pathname}${window.location.search}#/baby-info`;
            }}
          >
            <div className="menu-logo menu-baby-info" />
            <div>宝贝信息</div>
          </li>
          <li
            onClick={() => {
              window.location = `${window.location.pathname}${window.location.search}#/bind-weixin`;
            }}
          >
            <div className="menu-logo menu-bind-weixin" />
            <div
              style={
                page === "bind-weixin"
                  ? { color: "#8540FF", borderBottom: "1px solid #8540FF" }
                  : {}
              }
            >
              绑定微信
            </div>
          </li>
          <li
            onClick={() => {
              window.location = `${window.location.pathname}${window.location.search}#/my-gift?cid=${cid}`;
            }}
          >
            <div className="menu-logo menu-my-gift" />
            <div>我的礼物</div>
          </li>
          <li
            onClick={() => {
              window.location = `${window.location.pathname}${window.location.search}#/device`;
            }}
          >
            <div className="menu-logo menu-device-test" />
            <div
              style={
                page === "device"
                  ? { color: "#8540FF", borderBottom: "1px solid #8540FF" }
                  : {}
              }
            >
              设备检测
            </div>
          </li>
          <li
            onClick={() => {
              this.clearCookies();
            }}
          >
            <div className="menu-logo menu-logout" />
            <div>退出登录</div>
          </li>
        </ul>
        <button
          className="menu"
          onClick={() => this.setState({ showMenu: !showMenu })}
        /> */}
                {showInfo && (
                    <div
                        className={
                            showMenu
                                ? "baby-info-container-move baby-info-container"
                                : "baby-info-container"
                        }
                    >
                        <div
                            className="baby-avator-container"
                            onClick={() => {
                                window.location = `${window.location.pathname}${window.location.search}#/baby-info`;
                            }}
                        >
                            <div className="avator-border" />
                            <div
                                className="avator"
                                style={{
                                    background: photo
                                        ? `url(${photo}) no-repeat center / cover`
                                        : `url(${require("../../static/img/layout-menu/avator.png")}) no-repeat center / cover`
                                }}
                            />
                            <div className="baby-name">{eng_name}</div>
                        </div>
                        <div className="baby-star">
                            <div className="star" />
                            <div className="star-number">{stars}</div>
                        </div>
                        <div className="baby-putao-coin">
                            <div className="coin" />
                            <div className="coin-number">{grapes}</div>
                        </div>
                        <div
                            className="baby-gift"
                            onClick={() => {
                                window.location = `${window.location.pathname}${window.location.search}#/my-gift?cid=${cid}`;
                            }}
                        />
                        {
                            showLeaderBoard ?
                                <div
                                    className="plan-icon"
                                    onClick={() => {
                                        window.location = leaderBoardPageURL;
                                    }}
                                />
                                : null
                        }
                    </div>
                )}
                {showFM && (
                    <button
                        className="FM"
                        onClick={() => {
                            window.location = `${window.location.pathname}${window.location.search}#/FM`;
                        }}
                    />
                )}
                {this.props.children}
            </div>
        );
    }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/index/LayoutMenu.js